import { WidgetDefinition } from '../models/WidgetDefinition';

export const ReconciliationMeasureWidgetDefinition: WidgetDefinition = {
    baseType: 'ReconciliationMeasure',
    group: 'Reconciliation',
    hasImage: true,
    highlights: ['Measured and reconciled value in horizontal gauges', 'Gauges are colored according to correction penalty'],
    icon: 'fa-caret-square-o-right',
    sortingOrder: 900,
    title: 'Reconciliation values',
    type: 'ReconciliationMeasure'
};